import calendarSettingsStyles from "../../styles/calendarSettings.module.css";

type SectionSpacing = "small" | "medium" | "big"
type SectionTitleSize = "h2" | "h4"

const LabeledSection = ({
  title,
  icon,
  children,
  classes,
  extraOptions,
  spacing = "medium",
  titleSize = "h2"
}: {
  title: string,
  icon?: React.ReactNode,
  children: React.ReactNode,
  classes?: string,
  extraOptions?: React.ReactNode
  spacing?: SectionSpacing
  titleSize?: SectionTitleSize
}) => {

  const TitleTag = titleSize
  const getSpacing = (spacing: "small" | "medium" | "big") => {
    switch (spacing) {
      case "small": return "gap-[var(--spacing-md)]"
      case "medium": return "gap-[var(--spacing-lg)]"
      case "big": return "gap-[var(--spacing-xl)]"
    }
  }

  return (
    <section className={`
        ${titleSize === "h4" ? calendarSettingsStyles.labeledSectionSm : calendarSettingsStyles.labeledSection} 
        ${getSpacing(spacing)}
        ${classes ? classes : null}
      `}>
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <TitleTag>{title}</TitleTag>
          {icon}
        </div>
        {extraOptions}
      </div>
      {children}
    </section>
  )
}

export default LabeledSection